import BaseDataStore from '@/components/base/store/BaseDataStoreV1'

const BaseConst = {
  version: 1,
  storeName: 'M1901CoinsType',
  serviceName: 'M1901CoinsTypeService'
}
const M1901Const = new BaseDataStore(BaseConst)
export default M1901Const
